import { isEmpty } from "Util/isEmpty";
import { mergeStrings } from "Util/mergeStrings";
import { searchStringFrom } from "Util/searchStringFrom";
import { Nullable } from "./Nullable";

export type Name = {
    firstName: Nullable<string>
    lastName: Nullable<string>
    fullName: Nullable<string>
    searchStrings: {
        firstName: Nullable<string>
        lastName: Nullable<string>
        fullName: Nullable<string>
    }
}

function fullNameFrom(firstName: Nullable<string>, lastName: Nullable<string>) {
    return mergeStrings(' ', [firstName, lastName])
}

export function nameFrom(firstName: Nullable<string>, lastName: Nullable<string>): Nullable<Name> {
    if (isEmpty(firstName) && isEmpty(lastName)) {
        return null
    }
    const fullName = fullNameFrom(firstName, lastName)
    return {
        firstName,
        lastName,
        fullName,
        searchStrings: {
            firstName: searchStringFrom(firstName),
            lastName: searchStringFrom(lastName),
            fullName: searchStringFrom(fullName),
        },
    }
}
